import { CloseIcon } from '@lt/components/components/ResponsiveModal/components/CloseIcon';
import React from 'react';
import styles from './closeButton.module.css';

type Props = {
  onClick?(): void;
};

export const CloseButton = ({ onClick }: Props) => (
  <button className={styles.wrapper} onClick={onClick} type="button">
    <CloseIcon width={24} height={24} />
  </button>
);
